import Auth0 from 'auth0-js';
import qs from 'qs';
import store from 'store';
import queryStringParams from '../../services/queryStringParams';
import history from '../../services/history';
import _ from 'lodash';

// const callbackUrl = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_AUTH0_CALLBACK_URL_PROD_REPORTS : process.env.REACT_APP_AUTH0_CALLBACK_URL_DEV_REPORTS;
const callbackUrl = process.env.REACT_APP_NODE_ENV === 'production' ? process.env.REACT_APP_AUTH0_CALLBACK_URL_PROD_REPORTS : process.env.REACT_APP_AUTH0_CALLBACK_URL_DEV_REPORTS;

const auth0 = new Auth0.WebAuth({
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  redirectUri: callbackUrl,
  responseType: 'token id_token',
  scope: 'openid email',
});

export default {
  login: ({ language }) => {
    auth0.authorize({
      dict_title: 'Touch&Tell Reports',
      language,
    });
  },
  handleAuthentication: () => {
    const params = queryStringParams.get();
    let token = '';
    if (params.token) {
      token = params.token;
    } else {
      const hashString = history.location.hash.replace(/^#?\/?/, '');
      const authResult = qs.parse(hashString) || {};
      token = authResult.id_token;
    }
    store.set('auth', { token });
    const paramString = qs.stringify(_.omit(params, 'token'));
    if (paramString) {
      history.replace('/?' + paramString);
    } else {
      history.replace('/');
    }
  },
  token: () => {

    const storedAuth = store.get('auth') || {};

    let token;
    if (storedAuth.token) {
      token = storedAuth.token
    } else {
      const params = queryStringParams.get();
      if (params.token) {
        token = params.token;
        store.set('auth', { token });
      }
    }

    return token;
  },
  logout: () => {
    store.remove('auth');
    history.replace('/login');
  },
};



// WEBPACK FOOTER //
// ./src/services/auth/auth.js